<template>
  <div class="popover fade bottom in confirmation--popover">
    <div class="arrow confirmation--popover--arrow"></div>

    <div class="popover-content">
      <div class="close-chat--confirmation">
        <h1
          class="text--black text-center"
          v-html="$sanitizeHtml($t('conversation.header.endModal.title'))"
        />

        <div class="close-chat--confirmation--buttons--container">
          <button
            class="space-right-md"
            :style="`color: rgba(${settings.bgColorRGBA}); border: 1px solid rgba(${settings.bgColorRGBA}`"
            @click="handleDenyConfirmation"
          >
            {{ $t('conversation.header.endModal.noOption') }}
          </button>

          <button
            :style="`color: rgba(${settings.fontColorRGBA}); background-color: rgba(${settings.bgColorRGBA}`"
            @click="confirmConversationClose"
          >
            {{ $t('conversation.header.endModal.yesOption') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  import services from '@/services'

  export default {
    computed: {
      ...mapGetters(['settings', 'stories'])
    },
    methods: {
      ...mapActions([
        'closeConversation',
        'showClosingChatLoader',
        'disableEmojiPage',
        'toggleApp',
        'setShowStories',
        'disableVueperStories',
        'setSelectedStories'
      ]),
      confirmConversationClose() {
        this.showClosingChatLoader(true)

        this.disableEmojiPage()

        this.toggleApp()

        this.closeConversation()
          .then(() => {
            this.showClosingChatLoader(false)

            this.$emit('close')

            if (this.stories && typeof this.stories.medias !== 'undefined') {
              this.setShowStories(true)

              this.disableVueperStories()

              this.setSelectedStories(undefined)
            }

            services.iframe.postMessage({
              name: 'analytics',
              type: 'woz test widget close conversation'
            })
          })
          .catch(err => {
            console.error('Erro ao encerrar conversa: ', err)

            this.showClosingChatLoader(false)

            this.$emit('close')
          })
      },
      handleDenyConfirmation() {
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>
  .close-chat--confirmation {
    padding: 31px 27px 31px 27px;
  }

  .close-chat--confirmation button {
    display: block;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
    margin: 0;
    padding: 9px 13px;
    border-radius: 20px;
    cursor: pointer;
    font-size: 14px;
  }

  .close-chat--confirmation button:hover {
    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.15);
  }

  .close-chat--confirmation h1 {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: #757575;
    word-break: break-word;
    margin-top: 0;
  }

  .text--black {
    color: black;
  }

  .close-chat--confirmation--buttons--container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
  }

  .confirmation--popover {
    display: block;
    top: 25px;
    left: -307px;
    width: 335px;
  }

  .confirmation--popover--arrow {
    top: -10px;
    right: 8px;
    left: auto !important;
  }
</style>
